<!-- <img class="logo" src="./assets/images/background.jpg" alt=""> -->
<div class="authentication">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-4">
                <form class="card auth_form">
                    <div class="header">
                        <img class="logo" src="./assets/images/logo.png" alt="">
                    </div>
                    <div class="body">
                        <div class="row">
                        <div class="col-md-6 input-group">
                            <div class="form-group mb-1">
                                <label>Username </label>
                                <input type="text" class="form-control" placeholder="Username">
                            </div>
                        </div>
                        <div class="col-md-6 input-group">
                            <div class="form-group mb-1">
                                <label>Password</label>
                                <input type="password" class="form-control" placeholder="Password">
                            </div>
                        </div>

                    </div>
                        <div class="input-group">
                            <div class="form-group mb-1">
                                <label>Select Company</label>
                                <select class="form-control show-tick ms select2" data-placeholder="Select">
                                    <option>Select Company </option>
                                    <option>Select Item1</option>
                                    <option>Select Item2</option>
                                    <option>Select Item3</option>
                                    <option>Select Item4</option>
                                </select>
                            </div>
                        </div>
                        <div class="input-group ">
                            <div class="form-group mb-1">
                                <label>Select FY</label>
                                <select class="form-control show-tick ms select2" data-placeholder="Select">
                                    <option>Select FY </option>
                                    <option>Select Item1</option>
                                    <option>Select Item2</option>
                                    <option>Select Item3</option>
                                    <option>Select Item4</option>
                                </select>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="form-group mb-1">
                                <label>Login Date</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="zmdi zmdi-calendar"></i></span>
                                    </div>
                                    <input type="text" class="form-control datepicker"
                                        placeholder="Please choose date ...">
                                </div>
                            </div>
                        </div>
                        <div class="input-group ">
                            <div class="form-group mb-1">
                                <label>Select Shift</label>
                                <select class="form-control show-tick ms select2" data-placeholder="Select">
                                    <option>Select Shift </option>
                                    <option>Select Item1</option>
                                    <option>Select Item2</option>
                                    <option>Select Item3</option>
                                    <option>Select Item4</option>
                                </select>
                            </div>
                        </div>
                        <div class="checkbox">
                            <input id="remember_me" type="checkbox">
                            <label for="remember_me">Remember Me Next Time</label>
                        </div>
                        <div class="d-grid gap-2 d-md-flex justify-content-center">
                            <button class="btn brdbtn w-50" type="button">Cancel</button>
                            <button class="btn redbtn w-50" type="button" [routerLink]="['/kliq']">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>